<template>
  <div>
    <a-directory-tree
      v-if="gData.length > 0"
      @expand="onExpand"
      :default-expanded-keys="defaultExpandedKeys"
      :default-selected-keys="defaultSelectedKeys"
      :treeData="gData"
      @select="selectKey"
      :multiple="false"
      :showIcon="false"
      style="text-align: left"
    ></a-directory-tree>
  </div>
</template>

<script>
import { Tree } from 'ant-design-vue';

export default {
  name: 'LeftTree',
  components: {
    'a-directory-tree': Tree.DirectoryTree,
  },
  props: ['gData', 'defaultExpandedKeys', 'defaultSelectedKeys'],
  data() {
    return {
      expandedKeys: [],
    };
  },
  methods: {
    selectKey(selectedKeys) {
      this.$emit('selectKey', selectedKeys[0]);
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
    },
  },
};
</script>

<style lang="" scoped>
</style>
